export const BACKEND_HOST = "swimmer-reaction-timer-meter-api.sa.ngrok.io"

export const API_URL = "https://" + BACKEND_HOST + "/api/v1";
export const WEBSOCKET_URL = "wss://" + BACKEND_HOST + ":443";
